import React from "react";
import styled from "styled-components";
import { colors } from "../utils/theme";
import { useNavigate } from "react-router-dom";
const Container = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: row;
  background-color: ${colors.gris};
  h2 {
    color: ${colors.third};
    flex: 1;
    text-align: center;
    padding: 1.5rem 0;
    margin-right: 7rem;
  }

  .arrow {
    display: block;
    align-self: center;
    padding-left: 2rem;
    @media (max-width: 500px) {
      margin: 0 auto;
    }
    .bx {
      background-color: ${colors.blanco};
      font-size: 3rem;
      color: ${colors.fifth};
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

type TitleHeaderProps = {
  title?: string;
};



export const TitleHeader: React.FC<TitleHeaderProps> = ({ title = "AGENDA TU CITA" }) => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/");
  };

  return (
    <Container>
      <span className="arrow" onClick={handleNavigation}>
        <i className="bx bx-chevron-left"></i>
      </span>
      <h2>{title}</h2>
    </Container>
  );
};
